import { c as _c } from "react/compiler-runtime";
import { ADR } from '@/data/projects';
interface ADRCardProps {
  adr: ADR;
  index: number;
}
const ADRCard = t0 => {
  const $ = _c(21);
  const {
    adr,
    index
  } = t0;
  const t1 = index + 1;
  let t2;
  if ($[0] !== t1) {
    t2 = <span className="text-[10px] font-mono text-zinc-500 block mb-6 uppercase tracking-widest group-hover:text-primary transition-colors">Architectural Decision Record #0{t1}</span>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== adr.title) {
    t3 = <h3 className="text-3xl md:text-4xl font-serif italic text-white mb-8">{adr.title}</h3>;
    $[2] = adr.title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-[9px] font-mono text-primary uppercase tracking-widest mb-3 block opacity-70">The Problem</span>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== adr.problem) {
    t5 = <div>{t4}<p className="text-justify hyphens-auto text-sm font-sans leading-loose text-zinc-400">{adr.problem}</p></div>;
    $[5] = adr.problem;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="text-[9px] font-mono text-accent uppercase tracking-widest mb-3 block opacity-70">The Solution</span>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== adr.solution) {
    t7 = <div>{t6}<p className="text-justify hyphens-auto text-sm font-sans leading-loose text-zinc-400">{adr.solution}</p></div>;
    $[8] = adr.solution;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5 || $[11] !== t7) {
    t8 = <div className="grid grid-cols-1 md:grid-cols-2 gap-12">{t5}{t7}</div>;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="text-[9px] font-mono text-zinc-500 uppercase tracking-widest mb-3 block opacity-70">Measurable Impact</span>;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== adr.impact) {
    t10 = <div className="mt-8 pt-8 border-t border-white/5">{t9}<p className="text-sm font-mono italic text-zinc-200">{adr.impact}</p></div>;
    $[14] = adr.impact;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t2 || $[18] !== t3 || $[19] !== t8) {
    t11 = <div className="glass p-8 md:p-12 rounded-[2rem] hover:border-primary/20 transition-colors group">{t2}{t3}{t8}{t10}</div>;
    $[16] = t10;
    $[17] = t2;
    $[18] = t3;
    $[19] = t8;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
};
export { ADRCard };